import React from "react"

export default class Project extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			title: props.title,
			description: props.description,
			role: props.role,
			link: props.link,
			alink: props.alink,
			image: props.image,
			backgroundPosition: props.backgroundPosition
		}

	}

	// ** methods //

	handleClick(e) {
		if (e.target.classList.contains('inactive')) {
			e.preventDefault()
		}
	}

	// render

	render() {
		const { title, description, image, role, link, style, alink, backgroundPosition } = this.state 
		
    var divStyle = {
        backgroundImage: 'url(' + image + ')',
        backgroundPosition: backgroundPosition
    }

    var buttonClassName = "project__image__container__button" + ( link.length == 0 ? ' inactive' : '')

		return(
			<div className="project" id={alink}>
				<div className="project__description">
					<h1 className="scrollFirst" >{title}</h1>
					<h6 className="project__role scrollSecond"><span>Role</span> { role }</h6>
					<p className="scrollThird">{ description }</p>
				</div>
				<div className="project__image__container">
					<a className={buttonClassName} href={ link } target="_blank" onClick={ this.handleClick.bind(this)} >View Project</a>
					<div className="project__image__clip">
						<div className="project__image__container__image" style={divStyle} ></div>
					</div>
				</div>
			</div>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./js/components/project.js
 **/